import { PersonalDetails, PlayerDetails } from '@app/profile/models';

export class FetchPersonalDetails {
  static readonly type = '[Profile] Fetch personal details';

  constructor(public force: boolean = false) {}
}

export class SetPersonalDetails {
  static readonly type = '[Profile] Set personal details';

  constructor(public personalDetails: PersonalDetails) {}
}

export class FetchPlayerDetails {
  static readonly type = '[Profile] Fetch player details';

  constructor(public force: boolean = false) {}
}

export class SetPlayerDetails {
  static readonly type = '[Profile] Set player details';

  constructor(public playerDetails: PlayerDetails) {}
}

export class FetchProfilePicture {
  static readonly type = '[Profile] Fetch profile picture';

  constructor(public force: boolean = false) {}
}

export class SetProfilePicture {
  static readonly type = '[Profile] Set profile picture';

  constructor(public profilePicture?: string) {}
}

export class ResetProfile {
  static readonly type = '[Profile] Reset';
}
